// Start-time choices for services: every half hour, 6:00 AM to 9:30 PM, as
// 24h "HH:MM" values (the format plan edits already use).

export const SERVICE_TIMES: string[] = (() => {
  const out: string[] = [];
  for (let h = 6; h <= 21; h++) for (const m of ['00', '30']) out.push(`${String(h).padStart(2, '0')}:${m}`);
  return out;
})();

/** "09:30" -> "9:30 AM" */
export const timeLabel = (hhmm: string): string => {
  const [h, m] = hhmm.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};

/** Combine a local calendar date and "HH:MM" into an ISO timestamp. */
export const combineDateTime = (date: Date, hhmm: string): string => {
  const [h, m] = hhmm.split(':').map(Number);
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, 0, 0);
  return d.toISOString();
};
